module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("贡献者列表"), _c('span', {
    staticClass: "count"
  }, [_vm._v(" (目前有 "), _c('code', [_vm._v(_vm._s(_vm.contributors.length))]), _vm._v(" 个有为青年贡献了代码)")])]), _c('div', {
    staticClass: "tip"
  }, [_vm._v("\n无论是编辑文档还是提交代码都可以帮助 VUX 做得更好。\n")]), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.contributors), function(user) {
    return _c('li', [_c('a', {
      staticClass: "link",
      attrs: {
        "href": user.html_url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": user.avatar_url
      }
    }), _c('br'), _c('span', [_vm._v(_vm._s(user.login))])])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-596b6635", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-596b6635","preserveWhitespace":false}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./zh-CN/about/contributors.vue
// module id = 2263
// module chunks = 170